// Generated by purs version 0.15.15
import * as Data_Show from "../Data.Show/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var Cm = /* #__PURE__ */ (function () {
    function Cm(value0) {
        this.value0 = value0;
    };
    Cm.create = function (value0) {
        return new Cm(value0);
    };
    return Cm;
})();
var Mm = /* #__PURE__ */ (function () {
    function Mm(value0) {
        this.value0 = value0;
    };
    Mm.create = function (value0) {
        return new Mm(value0);
    };
    return Mm;
})();
var Inches = /* #__PURE__ */ (function () {
    function Inches(value0) {
        this.value0 = value0;
    };
    Inches.create = function (value0) {
        return new Inches(value0);
    };
    return Inches;
})();
var Px = /* #__PURE__ */ (function () {
    function Px(value0) {
        this.value0 = value0;
    };
    Px.create = function (value0) {
        return new Px(value0);
    };
    return Px;
})();
var Pt = /* #__PURE__ */ (function () {
    function Pt(value0) {
        this.value0 = value0;
    };
    Pt.create = function (value0) {
        return new Pt(value0);
    };
    return Pt;
})();
var Pc = /* #__PURE__ */ (function () {
    function Pc(value0) {
        this.value0 = value0;
    };
    Pc.create = function (value0) {
        return new Pc(value0);
    };
    return Pc;
})();
var Em = /* #__PURE__ */ (function () {
    function Em(value0) {
        this.value0 = value0;
    };
    Em.create = function (value0) {
        return new Em(value0);
    };
    return Em;
})();
var Ex = /* #__PURE__ */ (function () {
    function Ex(value0) {
        this.value0 = value0;
    };
    Ex.create = function (value0) {
        return new Ex(value0);
    };
    return Ex;
})();
var Rem = /* #__PURE__ */ (function () {
    function Rem(value0) {
        this.value0 = value0;
    };
    Rem.create = function (value0) {
        return new Rem(value0);
    };
    return Rem;
})();
var Vw = /* #__PURE__ */ (function () {
    function Vw(value0) {
        this.value0 = value0;
    };
    Vw.create = function (value0) {
        return new Vw(value0);
    };
    return Vw;
})();
var Vh = /* #__PURE__ */ (function () {
    function Vh(value0) {
        this.value0 = value0;
    };
    Vh.create = function (value0) {
        return new Vh(value0);
    };
    return Vh;
})();
var Vmin = /* #__PURE__ */ (function () {
    function Vmin(value0) {
        this.value0 = value0;
    };
    Vmin.create = function (value0) {
        return new Vmin(value0);
    };
    return Vmin;
})();
var Vmax = /* #__PURE__ */ (function () {
    function Vmax(value0) {
        this.value0 = value0;
    };
    Vmax.create = function (value0) {
        return new Vmax(value0);
    };
    return Vmax;
})();
var Pct = /* #__PURE__ */ (function () {
    function Pct(value0) {
        this.value0 = value0;
    };
    Pct.create = function (value0) {
        return new Pct(value0);
    };
    return Pct;
})();
var NoCSSLength = /* #__PURE__ */ (function () {
    function NoCSSLength() {

    };
    NoCSSLength.value = new NoCSSLength();
    return NoCSSLength;
})();
var showCSSLength = {
    show: function (v) {
        if (v instanceof Cm) {
            return "(Cm " + (show(v.value0) + ")");
        };
        if (v instanceof Mm) {
            return "(Mm " + (show(v.value0) + ")");
        };
        if (v instanceof Inches) {
            return "(Inches " + (show(v.value0) + ")");
        };
        if (v instanceof Px) {
            return "(Px " + (show(v.value0) + ")");
        };
        if (v instanceof Pt) {
            return "(Pt " + (show(v.value0) + ")");
        };
        if (v instanceof Pc) {
            return "(Pc " + (show(v.value0) + ")");
        };
        if (v instanceof Em) {
            return "(Em " + (show(v.value0) + ")");
        };
        if (v instanceof Ex) {
            return "(Ex " + (show(v.value0) + ")");
        };
        if (v instanceof Rem) {
            return "(Rem " + (show(v.value0) + ")");
        };
        if (v instanceof Vw) {
            return "(Vw " + (show(v.value0) + ")");
        };
        if (v instanceof Vh) {
            return "(Vh " + (show(v.value0) + ")");
        };
        if (v instanceof Vmin) {
            return "(Vmin " + (show(v.value0) + ")");
        };
        if (v instanceof Vmax) {
            return "(Vmax " + (show(v.value0) + ")");
        };
        if (v instanceof Pct) {
            return "(Pct " + (show(v.value0) + ")");
        };
        if (v instanceof NoCSSLength) {
            return "NoCSSLength";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.CSSLength (line 28, column 10 - line 43, column 33): " + [ v.constructor.name ]);
    }
};
var printCSSLength = function (v) {
    if (v instanceof Cm) {
        return show(v.value0) + "cm";
    };
    if (v instanceof Mm) {
        return show(v.value0) + "mm";
    };
    if (v instanceof Inches) {
        return show(v.value0) + "in";
    };
    if (v instanceof Px) {
        return show(v.value0) + "px";
    };
    if (v instanceof Pt) {
        return show(v.value0) + "pt";
    };
    if (v instanceof Pc) {
        return show(v.value0) + "pc";
    };
    if (v instanceof Em) {
        return show(v.value0) + "em";
    };
    if (v instanceof Ex) {
        return show(v.value0) + "ex";
    };
    if (v instanceof Rem) {
        return show(v.value0) + "rem";
    };
    if (v instanceof Vw) {
        return show(v.value0) + "vw";
    };
    if (v instanceof Vh) {
        return show(v.value0) + "vh";
    };
    if (v instanceof Vmin) {
        return show(v.value0) + "vmin";
    };
    if (v instanceof Vmax) {
        return show(v.value0) + "vmax";
    };
    if (v instanceof Pct) {
        return show(v.value0) + "%";
    };
    if (v instanceof NoCSSLength) {
        return "0";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.CSSLength (line 46, column 18 - line 61, column 21): " + [ v.constructor.name ]);
};
var eqCSSLength = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Cm && y instanceof Cm) {
                return x.value0 === y.value0;
            };
            if (x instanceof Mm && y instanceof Mm) {
                return x.value0 === y.value0;
            };
            if (x instanceof Inches && y instanceof Inches) {
                return x.value0 === y.value0;
            };
            if (x instanceof Px && y instanceof Px) {
                return x.value0 === y.value0;
            };
            if (x instanceof Pt && y instanceof Pt) {
                return x.value0 === y.value0;
            };
            if (x instanceof Pc && y instanceof Pc) {
                return x.value0 === y.value0;
            };
            if (x instanceof Em && y instanceof Em) {
                return x.value0 === y.value0;
            };
            if (x instanceof Ex && y instanceof Ex) {
                return x.value0 === y.value0;
            };
            if (x instanceof Rem && y instanceof Rem) {
                return x.value0 === y.value0;
            };
            if (x instanceof Vw && y instanceof Vw) {
                return x.value0 === y.value0;
            };
            if (x instanceof Vh && y instanceof Vh) {
                return x.value0 === y.value0;
            };
            if (x instanceof Vmin && y instanceof Vmin) {
                return x.value0 === y.value0;
            };
            if (x instanceof Vmax && y instanceof Vmax) {
                return x.value0 === y.value0;
            };
            if (x instanceof Pct && y instanceof Pct) {
                return x.value0 === y.value0;
            };
            if (x instanceof NoCSSLength && y instanceof NoCSSLength) {
                return true;
            };
            return false;
        };
    }
};
export {
    Cm,
    Mm,
    Inches,
    Px,
    Pt,
    Pc,
    Em,
    Ex,
    Rem,
    Vw,
    Vh,
    Vmin,
    Vmax,
    Pct,
    NoCSSLength,
    printCSSLength,
    eqCSSLength,
    showCSSLength
};
